export default "__VITE_ASSET__DCloONUS__"